webpackJsonp(["plugin--collapsible"],{

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/jquery__collapsible/collapsible.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// const log = debug(`plugins/${PLUGIN_NAME}`);

function getJSONValue(stringValue) {
	try {
		return JSON.parse(stringValue);
	} catch (error) {
		return stringValue;
	}
}

// TODO
// - update data-collapsible-open value on toggle


var Collapsible = function () {
	function Collapsible(element, options) {
		_classCallCheck(this, Collapsible);

		this.element = element;
		this.options = options;

		var scopes = {
			document: document,
			element: this.element
		};

		//	Look for the content element within this element or elsewhere
		var contentSelectorIsId = this.options.contentSelector && this.options.contentSelector[0] === '#';

		if (contentSelectorIsId) {
			this.contentSelectorScope = scopes['document'];
		} else {
			this.contentSelectorScope = scopes[this.options.contentSelectorScope] ? scopes[this.options.contentSelectorScope] : scopes['element'];
		}

		// if no button is specified perhaps this is the button
		this.button = this.options.buttonSelector ? this.element.querySelector(this.options.buttonSelector) : this.element;

		// Content is optional
		//	we may be toggling with CSS based on aria-expanded button attr
		this.content = this.options.contentSelector && this.contentSelectorScope.querySelector(this.options.contentSelector);
		this.collapseWith = this.options.collapsedClass ? 'class' : 'hidden';
		this.collapsedClass = this.options.collapsedClass;

		//	Unused but perhaps sometime useful methods
		// this.wasCollapsed =
		// 	this.collapseWith === 'class'
		// 		? this.hasToggleClass
		// 		: this.hasToggleHidden;

		this.toggleMethod = this.collapseWith === 'class' ? this.toggleWithClass : this.toggleWithHidden;

		this.attributeObserver = new MutationObserver(this.onAttributeChange.bind(this));

		this.init();
		this.watch();
	}

	_createClass(Collapsible, [{
		key: 'init',
		value: function init() {
			// component enabled - show the button
			this.button.hidden = false;

			// Determine initial collapse state
			//	if set open option determines init state
			var doCollapse = this.options.open !== undefined ? !this.options.open : true;

			this.toggleMethod(doCollapse);
			this.isCollapsed = doCollapse;
		}
	}, {
		key: 'watch',
		value: function watch() {
			this.button.addEventListener('click', this.toggle.bind(this));
			this.attributeObserver.observe(this.element, { attributes: true });
		}

		//	Unused but perhaps sometime useful methods
		// hasToggleClass() {
		// 	if (!this.content) {
		// 		return false;
		// 	}
		// 	return this.content.classList.contains(this.collapsedClass);
		// }

		// hasToggleHidden() {
		// 	if (!this.content) {
		// 		return false;
		// 	}
		// 	return this.content.hidden;
		// }

	}, {
		key: 'toggleWithHidden',
		value: function toggleWithHidden(doCollapse) {
			this.button.setAttribute('aria-expanded', !doCollapse);

			if (!this.content) {
				return false;
			}
			this.content.hidden = doCollapse;
		}
	}, {
		key: 'toggleWithClass',
		value: function toggleWithClass(doCollapse) {
			this.button.setAttribute('aria-expanded', !doCollapse);

			if (!this.content) {
				return false;
			}
			if (doCollapse) {
				this.content.classList.add(this.collapsedClass);
			} else {
				this.content.classList.remove(this.collapsedClass);
			}
		}

		// button click handler

	}, {
		key: 'toggle',
		value: function toggle() {
			if (!this.options.selfClosing && !this.isCollapsed) {
				return false;
			}

			var handler = this.isCollapsed ? this.open.bind(this) : this.close.bind(this);
			handler();
		}
	}, {
		key: 'open',
		value: function open() {
			this.toggleMethod(false);
			this.isCollapsed = false;

			var openedEvent = new CustomEvent("collapsible_opened", {
				bubbles: false,
				cancelable: true
			});
			this.element.dispatchEvent(openedEvent);
		}
	}, {
		key: 'close',
		value: function close() {
			this.toggleMethod(true);
			this.isCollapsed = true;
		}
	}, {
		key: 'onAttributeChange',
		value: function onAttributeChange(mutationList, observer) {
			mutationList.filter(function (mutation) {
				return mutation.type === 'attributes' && mutation.attributeName.startsWith('data-collapsible-open');
			}).forEach(this.onOpenChanged.bind(this));
		}
	}, {
		key: 'onOpenChanged',
		value: function onOpenChanged(mutation) {
			var doCollapse = !getJSONValue(this.element.dataset.collapsibleOpen);
			if (this.isCollapsed !== doCollapse) {
				this.toggleMethod(doCollapse);
				this.isCollapsed = doCollapse;
			}
		}
	}]);

	return Collapsible;
}();

Collapsible.DEFAULTS = {
	selfClosing: true
};

exports.default = Collapsible;

/***/ })

});


// WEBPACK FOOTER //
// scripts/plugin--collapsible--f5b2059c4dc5954e868b.js